import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-media-section',
  templateUrl: './media-section.component.html',
  styleUrls: ['./media-section.component.scss']
})
export class MediaSectionComponent implements OnInit {
  @Input() vehicleId!: string;
  @Input() type!: 'audio' | 'video';
  @Input() label!: 'Audio' | 'Video';
  @Input() mediaSrc?: string;
  @Input() phase!: 'Before' | 'After';
  @Input() parentPartId: string;
  @Input() openHandler!: (event: Event, type: 'audio' | 'video', phase: 'Before' | 'After') => void;
  @Output() onDeleteSuccess: EventEmitter<boolean> = new EventEmitter<boolean>();
  public isDeleting: boolean = false;

  constructor(private httpClient: HttpClient) {}

  ngOnInit(): void {}

  handleDeleteMedia(event: Event) {
    event.preventDefault();

    const url = `${environment().api}/delete/vehicle-audio-video`;
    const params = new HttpParams()
      .set('vehicle_id', this.vehicleId)
      .set('phase', this.phase.toLocaleLowerCase())
      .set('type', this.type)
      .set('parent_part_id', this.parentPartId);

    this.isDeleting = true;

    this.httpClient.delete(url, { params }).subscribe({
      next: (res) => {
        if (res?.['success']) {
          this.onDeleteSuccess.emit(res['success']);
          this.isDeleting = false;
        }
      },
      error: (error) => {
        console.log(error);
        this.isDeleting = false;
      }
    });
  }
}
